import { ErrorInfoVO } from '../vo/error-info.vo';

export class ErrorUtils {
  public static getErrorInfo(error: any): ErrorInfoVO {
    let errorType: string = '';
    let message: string = '';
    let title: string = '';
    try {
      errorType = error.error;
      title = error.title;
      message = error.message;
    } catch (e) {
      message = error.statusText;
    }
    return new ErrorInfoVO(errorType, title, message);
  }
}
